<template>
  <div class="ma-3">
    <OCol fill-x scroll-y class="pa-3 children-pa-3">
      <ORow class="gap-6">
        <div class="w-1/3">
          <v-text-field
            label="Nome/Apelido"
            v-model="value.name"
            hide-details
          />
        </div>
        <div class="w-1/3">
          <v-text-field
            label="Serial"
            v-model="value.serial"
            readonly
            disabled
            hide-details
          />
        </div>
        <div class="w-1/3">
          <!-- <BasePicker
            style="min-width: 300px"
            label="SIM Card"
            :value="simCardStr"
            icon="mdi-sim-outline"
            @open="showSimDetails"
            :clearable="false"
          /> -->
        </div>
      </ORow>

      <ORow class="gap-6">
        <div class="w-1/3">
          <DepotPicker
            v-model="value.depot"
            orientation="vertical"
            single
            whenEmpty="(nenhum)"
          />
        </div>

        <div class="w-1/3">
          <v-text-field
            label="Lote"
            v-model="value.batchNumber"
            hide-details
            append-icon="mdi-package-variant-closed"
            clearable
          />
        </div>

        <div class="w-1/3">
          <!-- <v-text-field
            label="MAC Address"
            v-model="value.macAddress"
            hide-details
            append-icon="mdi-memory"
            clearable
          /> -->
        </div>
      </ORow>

      <v-textarea label="Descrição" v-model="value.description" />

      <ORow>
        <OCapCont class="oderon-col-4" label="Criado em">
          {{ value.createdAt | moment('DD/MM/YYYY HH:mm') }}
        </OCapCont>
        <OCapCont class="oderon-col-4" label="Atualizado em">
          {{ value.updatedAt | moment('DD/MM/YYYY HH:mm') }}
        </OCapCont>
        <OCapCont class="oderon-col-4" label="Desativado em">
          {{ value.deletedAt | moment('DD/MM/YYYY HH:mm') }}
        </OCapCont>
      </ORow>

      <ORow right style="width: auto" class="mt-12">
        <v-btn text class="mr-2" :disabled="!isDirty" @click="$emit('reload')">
          Cancelar
        </v-btn>
        <v-btn color="primary" :disabled="!isDirty" @click="save">Salvar</v-btn>
      </ORow>
    </OCol>
  </div>
</template>

<script>
import EditStore from './EditStore'
import DepotPicker from '../../../components/pickers/DepotPicker.vue'

export default {
  tabTitle: 'Geral',
  components: {
    DepotPicker
  },
  computed: {
    value() {
      return EditStore.row
    },
    isDirty() {
      return EditStore.isDirty
    }
  },
  methods: {
    save() {
      this.$loading(async () => {
        const { id, name, description, serial, batchNumber } = this.value
        const depotId = this.value.depot && this.value.depot.id
        await EditStore.save({
          id,
          name,
          description,
          serial,
          depotId,
          batchNumber
        })
        this.$snack('Salvo com sucesso')
      })
    }
  }
}
</script>

<style></style>
